import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "../data/products";
import { waLink } from "../config/site";
import { MaskLine, FadeUp } from "./Reveal";

const ProductCard = ({ product, index }) => (
  <article
    data-testid={`product-card-${product.slug}`}
    className="group flex w-[78vw] shrink-0 flex-col sm:w-[46vw] md:w-full"
  >
    <Link
      data-testid={`product-view-link-${product.slug}`}
      to={`/products/${product.slug}`}
      className="relative block aspect-[4/5] overflow-hidden rounded-sm bg-bark focus:outline-none focus:ring-1 focus:ring-gold"
    >
      <img
        src={product.image}
        alt={product.name}
        loading="lazy"
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-espresso/50 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
      <span className="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-cream/90 text-espresso opacity-0 transition-all duration-500 group-hover:opacity-100">
        <ArrowUpRight size={16} />
      </span>
      <span className="absolute bottom-4 left-4 text-[10px] uppercase tracking-widest2 text-cream/80">
        {String(index + 1).padStart(2, "0")} — TMV
      </span>
    </Link>

    <div className="pt-6">
      <h3 className="font-display text-2xl text-cream transition-colors duration-300 group-hover:text-gold">
        {product.name}
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-cream/60">{product.short}</p>
      <p className="mt-3 text-xs uppercase tracking-[0.18em] text-sagelight">
        {product.aroma}
      </p>
      <div className="mt-5 flex items-center gap-6">
        <Link
          data-testid={`product-view-button-${product.slug}`}
          to={`/products/${product.slug}`}
          className="group/link relative text-xs font-medium uppercase tracking-[0.18em] text-gold"
        >
          View Product
          <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-100 bg-gold transition-transform duration-500 group-hover/link:scale-x-0" />
          <span className="absolute -bottom-1 left-0 h-px w-full origin-right scale-x-0 bg-gold transition-transform duration-500 delay-100 group-hover/link:scale-x-100" />
        </Link>
        <a
          data-testid={`product-enquire-button-${product.slug}`}
          href={waLink(`Hello TMV Coffee, I would like to enquire about ${product.name}.`)}
          target="_blank"
          rel="noopener noreferrer"
          className="text-xs font-medium uppercase tracking-[0.18em] text-cream/60 transition-colors duration-300 hover:text-cream"
        >
          Enquire Now
        </a>
      </div>
    </div>
  </article>
);

const Products = () => (
  <section id="products" data-testid="products-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <FadeUp>
            <p className="mb-5 text-[11px] uppercase tracking-widest2 text-gold">The Collection</p>
          </FadeUp>
          <h2 className="font-display text-4xl leading-tight text-cream sm:text-5xl">
            <MaskLine delay={0.05}>Crafted for every</MaskLine>
            <MaskLine delay={0.18} className="italic text-gold">
              quiet moment.
            </MaskLine>
          </h2>
        </div>
        <FadeUp delay={0.2} className="max-w-sm text-sm leading-relaxed text-cream/60">
          Four honest products — roasted, blended and packed for homes, cafés and businesses
          across Tamil Nadu and beyond.
        </FadeUp>
      </div>

      <div className="snap-row -mx-5 flex gap-6 overflow-x-auto px-5 pb-2 md:mx-0 md:grid md:grid-cols-2 md:overflow-visible md:px-0 lg:grid-cols-4">
        {PRODUCTS.map((p, i) => (
          <ProductCard key={p.slug} product={p} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Products;
